//
//
//
//
//
//
//
//
//
//
//
//
//

import Notice from '@/components/detail-new/Notice.vue';
var titleUrlMap = {
  // 演出延期
  13: 'https://obj.pipi.cn/festatic/common/image/49af6b409f2bd998bf349e7f19ac800e.png',
  // 演出取消
  14: 'https://obj.pipi.cn/festatic/common/image/94e6c188b97d33244fc9effa401537cc.png',
  // 部分延期
  15: 'https://obj.pipi.cn/festatic/common/image/b420e1857b8a60efb719883e88d42fa9.png',
  // 部分取消
  16: 'https://obj.pipi.cn/festatic/common/image/6931cc20207de41b89a79c89ce5f48a5.png',
  // 部分取消/延期
  17: 'https://obj.pipi.cn/festatic/common/image/c1ebd29d3d6611ca290151a32d6854cd.png'
};
// 演出延期/取消公告
export default {
  name: 'DelayNotice',
  components: {
    Notice: Notice
  },
  props: {
    performanceInfo: {
      type: Object,
      default: null
    },
    isNewPage: {
      type: Boolean
    }
  },
  computed: {
    noticeTitleUrl: function noticeTitleUrl() {
      var performanceInfo = this.performanceInfo;
      if (!performanceInfo) return '';
      return titleUrlMap[performanceInfo.saleStatus] || '';
    }
  }
};